import 'css-chunksrc/client/common/resourceSelection/search/styles.scss';export default {
  "search": "_search_1ko5k_1"
};